import { useCallback } from 'react';
import { useInsuranceCompanies, usePlans } from '../../app-init-data';

const useGetIcByJourney = ({ planId }: { planId: number }) => {
	const { getPlanById } = usePlans();
	const { getInsuranceCompanyById } = useInsuranceCompanies();

	const getInsuranceCompanyByPlanId = useCallback(() => {
		if (planId) {
			const insuranceCompanyId = getPlanById(planId)?.insuranceCompanyId;

			if (insuranceCompanyId) {
				return getInsuranceCompanyById(insuranceCompanyId);
			}
		}
	}, [getInsuranceCompanyById, getPlanById, planId]);

	return {
		getInsuranceCompanyByPlanId,
	};
};

export default useGetIcByJourney;
